import React, { useCallback, useMemo, useRef } from 'react';
import { setBtnPointLog } from "@/pages/dashboard/utils/utils";
import { IFilterValueType } from '../Filter/_type';
import Filter from '../Filter';


// 抽离公共业务筛选器组件，后续有公共逻辑可以直接加在这里，不用改所有页面的筛选器
// 如：当前的打点逻辑、filterVal全局状态存储以及后续添加筛选器保持、吸顶等

const CommonFilter = (props: any) => {
  const { onConfirm: filterConfirm, onReset: filterReset, onInit: filterInit, value: filterVal, setFilterVal, error,
    inputList, logConfig, filterIndex = 0, path, loading, children,selectorList, ...resetProps } = props || {};
  const filterLoadingRef = useRef<any>(true);

  const buttonLogConfig = useMemo(() => {
    const { pageId, typeId  } = logConfig || {};
    return {
      pageId,
      confirmButtonId: `${pageId}9${filterIndex}1`,
      resetButtonId: `${pageId}9${filterIndex}2`,
      typeId,
    };
  }, [logConfig, filterIndex]);

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value: IFilterValueType) => {
    filterInit?.(value);
    filterLoadingRef.current = false;
  }, [filterInit]);

  const onConfirm = useCallback((value: IFilterValueType) => {
    const isConfirm = filterConfirm?.(value);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    // 预留一些有限制查询条件，不让触发打点功能
    if(isConfirm === undefined || isConfirm === true){
      setBtnPointLog(buttonLogConfig, value);
    }
  }, [filterConfirm, buttonLogConfig]);

  const onReset = useCallback((value: IFilterValueType) => {
    filterReset?.(value);
    setBtnPointLog(buttonLogConfig, value, true);
  }, [filterReset, buttonLogConfig]);

  return <Filter
    {...resetProps}
    loading={loading}
    error={error}
    value={filterVal}
    inputList={inputList}
    onInit={onInit}
    onConfirm={onConfirm}
    onReset={onReset}
  >
    {
      children && React.Children.map(children, child => React.cloneElement(child, { filterVal,
        filterLoading: filterLoadingRef?.current,
        selectorList,
        filterError: error }))
    }
  </Filter>;
};

export default CommonFilter;
